export default __webpack_public_path__ + "static/media/collapse.38002ed8.svg";